export default (state) => state.TargetedComms.Smartcounts.campaign;

export const getProvisionalBase = (state) => state.TargetedComms.Smartcounts.campaign.provisionalBase;
